import type React from "react";
import { Bell, Search } from "lucide-react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { SidebarTrigger } from "../../ui/sidebar";
import { Separator } from "../../ui/separator";
import ThemeToggle from "../../common/ThemeToggle/ThemeToggle";

const Header: React.FC = () => {
	return (
		<header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
			<SidebarTrigger className="-ml-1" />
			<Separator orientation="vertical" className="mr-2 h-4" />
			<div className="flex-1" />
			<div className="flex items-center space-x-4">
				<div className="relative">
					<Search className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400" />
					<Input
						type="search"
						placeholder="検索..."
						className="pl-8 pr-4 py-1 rounded-full"
					/>
				</div>
				<ThemeToggle />
				<Button variant="ghost" size="icon">
					<Bell className="h-5 w-5" />
				</Button>
			</div>
		</header>
	);
};

export default Header;
